<template>
  <div class="v-icon">
    <span v-if="leftText" class="icon-left-text"
          :style="{ lineHeight: size+'px', height: size+'px'}">{{leftText}}</span>
    <Icon :custom="'iconfont ' + type" :size="size" />
    <span v-if="rightText" class="icon-right-text"
          :style="{ lineHeight: size+'px', height: size+'px'}">{{rightText}}</span>
  </div>
</template>

<script>
import '@/assets/font/iconfont.css';

export default {
  name: 'index',
  props: {
    type: {
      required: true,
      type: String,
      default: '',
    },
    size: {
      type: [String, Number],
      default: 24,
    },
    leftText: String,
    rightText: String,
  },
};
</script>

<style lang="less">
  .v-icon{
    display: inline-block;
    vertical-align: middle;
    .ivu-icon{
      vertical-align: middle;
    }
    .icon-left-text{
      margin-right: 8px;
      vertical-align: middle;
    }
    .icon-right-text{
      margin-left: 8px;
      vertical-align: middle;
    }
  }
</style>
